const uriProd = 'https://rpx.telin.com.my'
const uriTest = 'https://sandbox.rpx.telin.com.my'
const uriDev = 'http://localhost:3000'
const productionHosts = ['portal.rpx.telin.com.my', 'rpx.console.telinhk.website']
const isProduction = productionHosts.includes(window.location.host)
const isSandbox = window.location.host === 'develop.rpx-web-console.pages.dev'
const URL = isProduction ? uriProd : isSandbox ? uriTest : uriDev
const storageDevURL = 'http://127.0.0.1:9000'
const storageTestURL = 'https://testing.tmy-storage.telin.com.my'
const storageProdURL = 'https://gonilai.b-cdn.net' // old -> 'https://live.tmy-storage.telin.com.my'
export const StorageURL = isProduction ? storageProdURL : isSandbox ? storageTestURL : storageDevURL
export const bucket = {
  advertisements: 'advertisements',
  documents: 'documents',
}
//
export const appUrl = URL
export const moco = require('@mocobaas/client-js')
const clientProd = new moco.init(URL, {
  payloadEncryption: {
    enforcement: ['COMMON', 'FUNCTION', 'TABLE'],
  },
})
const clientTest = new moco.init(URL, {
  payloadEncryption: {
    enforcement: ['COMMON', 'FUNCTION', 'TABLE', 'GRAPHQL'],
    // enforcement: [],
  },
})
const clientDev = new moco.init(URL, {
  payloadEncryption: {
    enforcement: [],
  },
})
export const client = isProduction ? clientProd : isSandbox ? clientTest : clientDev
